
<!-- the transition / opacity style is to avoid a flash of unstyled content while loading the CSS file -->
<style>
.component-container {
   transition : opacity 0.1s linear;
   opacity: 0;
}
.loader-container {
   display: flex;
   justify-content: center;
   align-items: center;
}
.loader {
   border: 2px solid #DCEEFB;
   border-bottom-color: #135a99;
   border-radius: 50%;
   display: inline-block;
   box-sizing: border-box;
   animation: rotation 1s linear infinite;
}

@keyframes rotation {
   0% {
         transform: rotate(0deg);
   }
   100% {
         transform: rotate(360deg);
   }
}
/* will be overridden by external CSS to show */
.component-container {
   display: hidden;
}
/* webfont is also loaded, but via JS due to path */
</style>

<div [style]="{'height': height}" class="loader-container" [attr.aria-label]="t('app.loader')" *transloco="let t">
   <div class="loader" style="height:50px;width:50px;"></div>
</div>
<div aria-live="polite" toastContainer></div>
<!-- the scale-[1] is sorcery found on SO to make sure the dark semi-opaqua background of the sidenav does not expand outside of the shadow dom root -->
<div class="component-container !opacity-100 group h-screen flex-col lg:flex-row bg-zinc-100 gap-x-2 md:gap-x-5 font-sourcesans scale-[1]"

   [style]="{'height': height}"
   *transloco="let t"
   [attr.data-showsidenav]="showSideNavCurrent">

   <nav class="flex flex-col
         w-full
       bg-white
         border-b-2 border-b-zinc-400
         z-20
         h-auto

         lg:shadow-none
         lg:my-5
         lg:ms-5
         lg:w-1/4
         lg:border-none
         lg:rounded-lg

         group-data-[showsidenav=true]:absolute
         group-data-[showsidenav=true]:shadow-xl
         group-data-[showsidenav=true]:border-left-1
         group-data-[showsidenav=true]:w-3/4
         group-data-[showsidenav=true]:h-full

         lg:group-data-[showsidenav=true]:w-1/4
         lg:group-data-[showsidenav=true]:shadow-none
         lg:group-data-[showsidenav=true]:relative
         lg:group-data-[showsidenav=true]:h-auto

         group-data-[showsidenav=false]:ms-0
         group-data-[showsidenav=false]:basis-0
         group-data-[showsidenav=false]:bg-transparent
         ">
      <button class="skiplink absolute left-1/2" (click)="skipTo('default-search')">{{ t('landing.skiplink') }}</button>
      <app-navigation></app-navigation>
   </nav>
   <div class="hidden lg:group-data-[showsidenav=true]:hidden group-data-[showsidenav=true]:block group-data-[showsidenav=true]:fixed inset-0 bg-black bg-opacity-55 z-10"></div>
   <main class="flex
         lg:overflow-y-clip
         overflow-y-auto
         bg-white
         w-full
         justify-center
         h-[calc(100%-4rem)]

         lg:w-3/4
         lg:h-auto
         lg:my-5
         lg:me-5
         lg:rounded-lg

         lg:group-data-[showsidenav=true]:w-3/4
         lg:group-data-[showsidenav=false]:w-full
         ">

      <router-outlet></router-outlet>
   </main>
</div>

